import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexTemplateKeysRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/template_keys', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const debounceIndexTemplateKeysRequest = AwesomeDebouncePromise(indexTemplateKeysRequest, 300);
